export default __webpack_public_path__ + "static/media/about.2cfc9b7f.svg";